import { get as getBookingPanelAdvert } from './bookingPanelSponsoredPricingOption/selectors';

import type { AdvertStateBookingPanel } from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/entities/advertsBookingPanel';

export const bookingPanelAdvert = (
  state: AdvertStateBookingPanel,
): AdvertStateBookingPanel['bookingPanelSponsoredPricingOption']['advert'] =>
  getBookingPanelAdvert(state.bookingPanelSponsoredPricingOption);
